import * as CryptoJS from "crypto-js";

export class IdGenerator {
  public static generateId(): string {
    const random = CryptoJS.lib.WordArray.random(16);

    random.words[4] = (random.words[4] & 0x0fffffff) | 0x40000000;
    random.words[3] = (random.words[3] & 0x3fffffff) | 0x80000000;

    const hex = random.toString(CryptoJS.enc.Hex);
    return (
      hex.substring(0, 8) +
      "-" +
      hex.substring(8, 12) +
      "-" +
      hex.substring(12, 16) +
      "-" +
      hex.substring(16, 20) +
      "-" +
      hex.substring(20)
    );
  }
}
